/* You can add your custom scripts here */

const excludedProducts = document.querySelector('.excluded_products');

document.addEventListener('click', function(event) {
    if (!excludedProducts.contains(event.target)) {
    excludedProducts.removeAttribute('open');
  }
});

document.addEventListener("click", (e) => {
  if (e.target.closest('.excluded_products-close')) {
    excludedProducts.removeAttribute('open');
  }
});
